import { Editor, track } from '@tldraw/tldraw'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { ToolbarButton } from '../../components/ToolbarButton'
import { ImageShapeUtil } from 'components/VisualStudioPlayground/Shapes/ImageShape/ImageShapeUtil'
import Expand2 from 'blaze-ui/icons/20/Expand2'
import { radiansToDegrees } from 'components/Design/ShapesTab/components/Rotation'

interface Props {
  editor: Editor
  selectedShape: ImageShape
}

const validRotations = [0, 360]

export const isValidRotation = (rotation: number) => {
  return validRotations.includes(Math.round(radiansToDegrees(rotation)))
}

export const FillCanvasButton = track(({ editor, selectedShape }: Props) => {
  const util = editor.getShapeUtil(selectedShape) as ImageShapeUtil

  if (!isValidRotation(selectedShape.rotation)) {
    return null
  }

  return (
    <ToolbarButton
      frontIcon={Expand2}
      onPress={() => {
        util.fitShapeToCanvas(selectedShape)
      }}
    >
      Fill Canvas
    </ToolbarButton>
  )
})
